import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';

const Layout = ({ children, showNavigation = true, showFooter = true, villaData = null, onBooking = null }) => {
  return (
    <>
      {showNavigation && <Navigation villaData={villaData} onBooking={onBooking} />}
      {children}
      {showFooter && <Footer />}
    </>
  );
};

export default Layout;